module.exports = __webpack_public_path__ + "img/unihockey_Tigers.7e2d32f3.png";